import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const LoginView = () => import('@/views/LoginView.vue');
const DashboardView = () => import('@/views/DashboardView.vue');
const EventsView = () => import('@/views/EventsView.vue');
const EventDetailView = () => import('@/views/EventDetailView.vue');

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    {
      path: '/',
      name: 'dashboard',
      component: DashboardView,
    },
    {
      path: '/events',
      name: 'events',
      component: EventsView,
    },
    {
      path: '/events/new',
      name: 'event-create',
      component: EventDetailView,
      props: () => ({ id: null }),
    },
    {
      path: '/events/:id(\\d+)',
      name: 'event-detail',
      component: EventDetailView,
      props: (route: RouteLocationNormalized) => ({ id: Number(route.params.id) }),
    },
    { path: '/:pathMatch(.*)*', redirect: '/events' },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (!auth.restored) await auth.restoreSession();

  if (to.meta.public) {
    if (auth.isAuthenticated && to.name === 'login') {
      return { name: 'events' };
    }
    return true;
  }

  if (!auth.isAuthenticated) {
    return { name: 'login', query: { next: to.fullPath } };
  }
  return true;
});
